import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5aceeacc&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/bootstrap.css?vue&type=style&index=0&id=5aceeacc&prod&scoped=true&lang=css&"
import style1 from "../assets/css/style.css?vue&type=style&index=1&id=5aceeacc&prod&scoped=true&lang=css&"
import style2 from "../assets/css/flaticon-set.css?vue&type=style&index=2&id=5aceeacc&prod&scoped=true&lang=css&"
import style3 from "./About.vue?vue&type=style&index=3&id=5aceeacc&prod&scoped=true&lang=css&"
import style4 from "./About.vue?vue&type=style&index=4&id=5aceeacc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aceeacc",
  null
  
)

export default component.exports